module.exports = __webpack_public_path__ + "static/media/smallMedal_2.50011b16.png";